module.exports = __webpack_public_path__ + "static/media/covi_str.352bb5c2.png";